import { PaymentsModule } from './PaymentsModule';

export const Payments = () => {
  return <PaymentsModule flavor={'Standard'} />;
};
